import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import * as analytics from 'analytics/Analytics';
import {WORKFLOWS_ANALYTICS_ACTIONS} from 'constants/AnalyticsConstants';
import FileBrowserActions from 'file-browser/FileBrowserActions';
import {isInaccessible} from 'graphql-client/InaccessibleInfo';
import {LEGACY_FONT_PROXIMA_14, LEGACY_FONT_PROXIMA_TITLE} from 'styles/FontConstants';
import {AvatarSize} from 'ui-library/avatar/AvatarConstants';
import {BLUE_LIGHT} from 'ui-library/Colors';
import {FloatingPlacement} from 'ui-library/floating-ui/FloatingConstants';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import PartyAvatarList from 'ui-library/PartyAvatarList';

import {ProcessTaskForCalendarGraphQL} from '../../graphql-fragments/processes/__generated/ProcessTaskForCalendarGraphQL';
import CalendarUtil from './CalendarUtil';

export default function ProcessTaskSummary(props: {processTask: ProcessTaskForCalendarGraphQL}): JSX.Element {
  return (
    <div className="u-spacing-bottom">
      <div className={classNames(css(styles.header), 'u-lr-split')}>
        <div
          className="u-pointer"
          onClick={() => {
            FileBrowserActions.openFile(props.processTask.process.id);
            analytics.trackEvent(WORKFLOWS_ANALYTICS_ACTIONS.OPENED_TASK_FROM_CALENDAR_ITEM_MODAL, {
              process_client_origin: !isInaccessible(props.processTask.taskSchema)
                ? props.processTask.taskSchema.clientOrigin
                : null,
              task_group_api_id: props.processTask.process.id,
              task_api_id: props.processTask.id,
            });
          }}
        >
          <BenchlingIcon icon="process-task" className={css(styles.icon)} />
          {props.processTask.humanId}
        </div>
        <PartyAvatarList
          size={AvatarSize.XXSMALL}
          maxAvatars={3}
          parties={CalendarUtil.getItemParties(props.processTask)}
          tooltipPlacement={FloatingPlacement.TOP}
        />
      </div>
      <div>
        <div className={css(styles.assigneeText)}>
          {props.processTask.assignee != null
            ? `Assigned to: ${props.processTask.assignee.name}`
            : 'Unassigned'}
        </div>
      </div>
    </div>
  );
}

const styles = StyleSheet.create({
  icon: {
    marginRight: 6,
  },
  assigneeText: {
    wordBreak: 'break-word',
    ...LEGACY_FONT_PROXIMA_14,
  },
  header: {
    color: BLUE_LIGHT,
    ...LEGACY_FONT_PROXIMA_TITLE,
    marginBottom: 4,
    ':hover': {
      color: BLUE_LIGHT,
    },
  },
});
